import React, { useState } from 'react';
import { connect } from "react-redux";
import ReactDOM from 'react-dom';

import {
    EstateSearchResultsList,
    EstateSearchResultsMap,
} from '/components/estate-search/components';

import { LocalStorageService } from '/services';

const intersection = (arrayOne, arrayTwo) => {
    return arrayOne.filter(xxx => arrayTwo.includes(xxx));
};

const InternalEstateSearchResults = ({ allEstates, filterValues }) => {
    const {
        categories,
        groups,
        priceClasses,
        locations,
        search,
        searchResults,
        surfaceMin,
        surfaceMax,
        minPrice,
        maxPrice,
    } = filterValues;

    const estateSearchResultsContainer = document.querySelector(
        '[data-estate-search-results]',
    );

    if (Boolean(estateSearchResultsContainer) === false) {
        return null;
    }

    let initialShowMap = false;
    if (window.estateOverview.allowMapView && window.innerWidth > 959) {
        initialShowMap = LocalStorageService.get('showMap') || false;
    }

    const [showMap, internalSetShowMap] = useState(initialShowMap);

    const setShowMap = (value) => {
        LocalStorageService.set('showMap', value);
        internalSetShowMap(value);
    };

    let selectedEstates = allEstates;

    if (categories.length > 0) {
        selectedEstates = selectedEstates.filter((estate) => {
            return intersection(estate.categories, categories).length > 0;
        });
    }

    if (groups.length > 0) {
        selectedEstates = selectedEstates.filter((estate) => {
            return intersection(estate.purposes, groups).length > 0;
        });
    }

    if (priceClasses.length > 0) {
        selectedEstates = selectedEstates.filter((estate) => {
            return intersection(estate.priceClasses, priceClasses).length > 0;
        });
    }

    if (locations.length > 0) {
        selectedEstates = selectedEstates.filter((estate) => {
            return intersection(estate.locations, locations).length > 0;
        });
    }

    if (search) {
        selectedEstates = selectedEstates.filter((estate) => {
            return searchResults.includes(estate.id);
        });
    }

    if (surfaceMin) {
        selectedEstates = selectedEstates.filter((estate) => {
            return estate.minArea >= surfaceMin;
        });
    }

    if (surfaceMax) {
        selectedEstates = selectedEstates.filter((estate) => {
            return estate.area <= surfaceMax;
        });
    }

    if (minPrice) {
        selectedEstates = selectedEstates.filter((estate) => {
            return estate.priceForSorting >= parseInt(minPrice);
        });
    }

    if (maxPrice) {
        selectedEstates = selectedEstates.filter((estate) => {
            return estate.priceForSorting <= parseInt(maxPrice);
        });
    }

    return ReactDOM.createPortal(
        <div className="gallery-and-map">
            {window.estateOverview.allowMapView && showMap && allEstates.length > 0 && (
                <div className="gallery-and-map__map">
                    <EstateSearchResultsMap
                        hits={selectedEstates}
                        showMap={showMap}
                        setShowMap={setShowMap}
                    />
                </div>
            )}
            <div className="gallery-and-map__gallery">
                <EstateSearchResultsList
                    hits={selectedEstates}
                    showMap={showMap}
                    setShowMap={setShowMap}
                />
            </div>
        </div>,
        estateSearchResultsContainer,
    );
};

const mapStateToProps = state => {
    return {
        allEstates: state.categories.allEstates,
        filterValues: state.filterValues
    };
};

const EstateSearchResults = connect(
    mapStateToProps,
    null,
)(InternalEstateSearchResults);

export { EstateSearchResults };
